import { IComment } from '@/shared/IComment';
import { Badge, HStack, Tooltip, Box } from '@chakra-ui/react';
import { COMMENT_STATUS } from '@/shared/constants';
import { CommentsService } from '../services/CommentsService';
import { formatDateFromNow } from '@/shared/parse';
import { FiMessageSquare } from 'react-icons/fi';
import { ICourse } from '@/shared/ICourse';
import { AuthService } from '../services/AuthService';

export const CommentSetBadge = (props: {
  course: ICourse;
  filter?: (comment: IComment) => boolean,
  onClick?: (status: COMMENT_STATUS) => void
}) => {

  const commentSet = props.course?.commentSet || {};

  const counterSet = {
    [COMMENT_STATUS.COMMENT]: {
      last: '',
      username: '',
      count: 0
    },
    [COMMENT_STATUS.ACTION_REQUIRED]: {
      last: '',
      username: '',
      count: 0
    },
    [COMMENT_STATUS.RESOLVED]: {
      last: '',
      username: '',
      count: 0
    },
    [COMMENT_STATUS.REOPENED]: {
      last: '',
      username: '',
      count: 0
    },
  };

  for (const id in commentSet) {

    const comment = commentSet[id];
    if (comment.threadId || props.filter && !props.filter(comment)) {
      continue;
    }

    const counter = counterSet[comment.status ?? COMMENT_STATUS.COMMENT];
    if (counter) {

      if (comment.timestamp > counter.last) {
        counter.last = comment.timestamp;
        counter.username = comment.username || ''
      }

      ++counter.count;
    }
  }

  const onCommentClick = (e: React.MouseEvent) => {
    if (props.onClick) {
      props.onClick(e.currentTarget.textContent as COMMENT_STATUS);
    }
  }

  const counters = Object
    .keys(counterSet)
    .map((key: string) => {
      const counter = counterSet[key as COMMENT_STATUS];
      return {
        status: key,
        count: counter.count,
        last: counter.last,
        username: counter.username,
      }
    })
    .filter(x => x.count > 0);

  return AuthService.isExternalExpert(props.course)
    ? null
    : <HStack wrap='wrap' spacing="1">
      {counters.map((item) => (
        <Tooltip key={item.status} label={`Last comment: ${formatDateFromNow(item.last)} by ${item.username}`}>
          <Badge onClick={onCommentClick} size="sm" cursor='pointer' colorScheme={CommentsService.getCommentStatusColor(item.status)}>
            <HStack spacing="1">
              <FiMessageSquare />
              <Box>{CommentsService.getCommentStatusText(item.status)}: {item.count}</Box>
            </HStack>
          </Badge>
        </Tooltip>
      ))}
    </HStack>
}